import {createFeatureSelector, createSelector} from '@ngrx/store';
import {FiltroModel} from './feature-filtro.model';

export const featureKeyFiltro = 'filtro';
export const selectFeature = createFeatureSelector<FiltroModel>(featureKeyFiltro);

export const getFiltro = createSelector(selectFeature, (state) => state);

